import { OptionWithValues, useProductOptions } from '@shopify/hydrogen';
import ProductOptionsDefault from './ProductOptionsDefault.client';

/**
 * A client component that tracks a selected variant and/or selling plan state, as well as callbacks for modifying the state
 */

export default function ProductOptions() {
  const { options } = useProductOptions();

  return (
    <>
      <div>
        {(options as OptionWithValues[])?.map(({ name, values }) => {
          return (
            <ProductOptionsDefault key={name} name={name} values={values} />
          );
        })}
      </div>
    </>
  );
}
